import { render } from "./CampaignsComponentUsb.vue?vue&type=template&id=f5c614ee"
import script from "./CampaignsComponentUsb.vue?vue&type=script&lang=js"
export * from "./CampaignsComponentUsb.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__